module.exports = __webpack_public_path__ + "media/images/photos/gradient1-48a3ce9bf9d72be1638746cd2c6db95e.jpg";